import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import axios from "axios";
import "./InterviewerDashboard.css";

const InterviewerDashboard = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  let navigate = useNavigate();
  useEffect(() => {
    document.title = "Profile - John Doe";
  });
  const [profiledata, setProfileData] = React.useState("");
  useEffect(() => {
    async function fetchData() {
      //console.log(`http://localhost:8585/send/interviewrs/${JSON.parse(localStorage.getItem("isIAuthenticated")).Id}`)
      await axios
        .get(
          `${process.env.REACT_APP_SERVER_URL}/send/interviewrs/${
            JSON.parse(localStorage.getItem("isIAuthenticated")).Id
          }`
          // "http://localhost:8585/send/interviewrs/112498486441550091107"
        )
        .then((response) => {
          setProfileData(response.data);
          console.log(profiledata);
        })
        .catch((error) => {
          console.log("ERROR");
          console.log(error);
        });
    }
    fetchData();
  }, []);

  return (
    <>
      <div className="interviews w-full">
        <div className="w-full p-2 my-2 border-2 rounded flex justify-center">
          <Typography
            variant="h4"
            component="h4"
            sx={{
              // textAlign: "center",
              display: "inline",
              color: "#1265a8",
              fontWeight: "bold",
              margin: "0 auto",
            }}
          >
            My Profile
          </Typography>
        </div>
        <div className="grid mx-2" id="profile-cont">
          <div className="m-2 overflow-hidden">
            <div className="border rounded mb-4">
              <div className="h-32 opacity-80 overflow-hidden">
                <img src={require("../../images/cover2.webp")} alt="Cover" />
              </div>
              <div className="relative grid py-2" id="profile-bio">
                <div className="relative">
                  <div className="absolute w-40 -top-16 left-3 mx-auto">
                    <img
                      src={require("../../images/photo.png")}
                      className="w-full h-full object-cover rounded-full p-1 border bg-white"
                      alt="Profile"
                    />
                  </div>
                </div>
                <div>
                  <Typography
                    variant="h4"
                    component="h4"
                    sx={{
                      color: "#e84c3d",
                      fontWeight: "bold",
                    }}
                  >
                    John Doe
                    {/* {profiledata.dfname} */}
                  </Typography>
                  <Chip
                    // label={`${profiledata.designation} ${profiledata.company} ${profiledata.location}`}
                    label={"SDE II, Google, India"}
                    sx={{ fontSize: "16px" }}
                  />

                  <p className="text-gray-500 leading-5"></p>
                  <div className="text-2xl my-1 mt-3 flex w-40 justify-between">
                    <div className="hover:text-blue-500 hover:bg-gray-100 text-blue-500 cursor-pointer border rounded p-2 w-12 text-center">
                      <i
                        className="fa-brands fa-linkedin"
                        onClick={() => {
                          window.open(
                            profiledata.linkedInURL
                              ? profiledata.linkedInURL
                              : "/dashboard",
                            "_blank"
                          );
                        }}
                      ></i>
                    </div>
                    <div className="hover:text-blue-500 hover:bg-gray-100 text-black cursor-pointer border rounded p-2 w-12 text-center">
                      <i
                        className="fa-brands fa-github"
                        onClick={() => {
                          window.open(
                            profiledata.githubURL
                              ? profiledata.githubURL
                              : "/dashboard",
                            "_blank"
                          );
                        }}
                      ></i>
                    </div>
                    <div className="hover:text-blue-500 hover:bg-gray-100 text-blue-500 cursor-pointer border rounded p-2 w-12 text-center">
                      <i
                        className="fa-brands fa-twitter"
                        onClick={() => {
                          window.open(
                            profiledata.twitterURL
                              ? profiledata.twitterURL
                              : "/dashboard",
                            "_blank"
                          );
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="relative h-full">
                  <div className="w-20 border rounded-md mx-auto my-2 px-2 py-1">
                    <img
                      src={require("../../images/google.png")}
                      alt="iitd"
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div
                    className="absolute bottom-0 right-1 text-center border rounded-md p-1 mx-auto text-green-600 cursor-pointer hover:text-blue-600 hover:bg-gray-100"
                    onClick={() => {
                      navigate("/interviewer/profile-form");
                    }}
                  >
                    <p>
                      <i className="fa-solid fa-pen-to-square"></i> Edit Profile
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded border p-2">
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                }}
              >
                Description
              </Typography>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut,
                sapiente? Nihil voluptates quasi temporibus omnis iure doloribus
                molestiae doloremque odit, cum at hic beatae ut iusto,
                necessitatibus magnam officiis perferendis.
                {profiledata.desc}
              </p>
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                Time Preferences
              </Typography>
              <div>
                <div className="my-2">
                  <Chip label="Mon (5PM - 7PM)" variant="outlined" />
                </div>
                <div className="my-2">
                  <Chip label="Wed (5PM - 7PM)" variant="outlined" />
                </div>
                <div className="my-2">
                  <Chip label="Sun (5PM - 7PM)" variant="outlined" />
                </div>
              </div>
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                Profile Preferences
              </Typography>
              <div>
                <Chip label="Software" variant="outlined" />
                <Chip label="Data Analysis" variant="outlined" />
              </div>
            </div>
          </div>
          <div className="border rounded p-2 m-2 my-2">
            <div>
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Feeds
              </Typography>
              <div className="border rounded drop-shadow-lg my-2">
                <img
                  src={require("../../images/join-now.jpg")}
                  alt="Join Now"
                />
              </div>
              <div className="border rounded p-1 py-2 text-justify">
                <p className="text-sm font-medium">
                  Would you like to see the students who are interested to have
                  a Mock Interview with you and obtain your Feedback on their
                  performance in real time?
                </p>
                <div className="flex justify-center mt-1">
                  <Button
                    variant="contained"
                    sx={{ textAlign: "center", fontSize: 11 }}
                    onClick={() => {
                      navigate("/interviewer/request");
                    }}
                  >
                    Check Mock Interview Requests
                  </Button>
                </div>
              </div>
              <Typography
                variant="h6"
                component="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Interview Metrics
              </Typography>
              <div>
                <img src={require("../../images/graph.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterviewerDashboard;
